<template>
  <div class="register">
    <v-stepper class="stepper" v-model="selectedStep">
      <v-stepper-header>
        <v-stepper-step color="green" step="1"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="2"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="3"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="4"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="5"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="6" complete></v-stepper-step>
      </v-stepper-header>

      <v-stepper-items class="items">
        <v-stepper-content class="content" step="1">
          <h1>Gib jetzt deine persönlichen Daten ein.</h1>
          <h3>Schritt 1 von 2</h3>

          <hr class="green-line" />

          <label>Vorname <span>*</span></label>
          <v-text-field
            :rules="[rules.required]"
            color="green"
            v-model="common_infos.vorname"
            solo
          ></v-text-field>

          <label>Nachname <span>*</span></label>
          <v-text-field
            :rules="[rules.required]"
            color="green"
            v-model="common_infos.nachname"
            solo
          ></v-text-field>

          <label>
            Geburtsdatum
            <span>*</span>
          </label>
          <v-menu
            ref="menu"
            v-model="menu"
            locale="de"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            full-width
            color="green"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                color="green"
                v-model="settings.birthday"
                prepend-icon="event"
                readonly
                solo
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              color="green"
              ref="picker"
              locale="de"
              v-model="settings.birthday"
              :max="new Date().toISOString().substr(0, 10)"
              min="1900-01-01"
            ></v-date-picker>
          </v-menu>

          <label>
            Geschlecht
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="sex"
            v-model="settings.gender"
            solo
          ></v-select>

          <v-btn color="white green--text" @click="backToRegister" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            :disabled="
              !common_infos.vorname ||
              !common_infos.nachname ||
              !settings.birthday ||
              !settings.gender
            "
            @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="2">
          <h1>Gib weitere persönliche Daten ein.</h1>
          <h3>Schritt 2 von 2</h3>

          <hr class="green-line" />

          <label> Nationalität <span>*</span> </label>
          <v-autocomplete
            :no-data-text="'Keine Einträge vorhanden'"
            :items="$store.state.nationalities"
            item-text="item_text"
            item-value="id"
            color="green"
            name="nationalities"
            v-model="settings.nationality"
            solo
            attach
          ></v-autocomplete>

          <label>Sprachen <span>*</span></label>
          <v-select
            solo
            v-model="settings.languages"
            color="green"
            :items="$store.state.languages"
            chips
            multiple
          ></v-select>

          <h2 class="middle_header">Aktueller Wohnsitz <span>*</span></h2>

          <!-- <label>Postleitzahl <span>*</span></label> -->
          <v-text-field
            color="green"
            v-model="common_infos.zip_code"
            mask="#####"
            placeholder="Postleitzahl"
            solo
          ></v-text-field>

          <!-- <label>Ort, Bundesland</label> -->
          <v-text-field
            color="green"
            v-model="common_infos.ort_bundesland"
            placeholder="Ort, Bundesland"
            solo
          ></v-text-field>

          <!-- <label>
            Wohnsitz (Land)
            <span>*</span>
          </label> -->
          <v-autocomplete
            color="green"
            :items="$store.state.countries"
            v-model="settings.place_of_living"
            placeholder="Land"
            solo
          ></v-autocomplete>

          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            :disabled="
              !(settings.languages && settings.languages.length) ||
              !settings.nationality ||
              !settings.place_of_living ||
              !common_infos.zip_code
            "
            @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="3">
          <h1>Ein Profilbild ist immer vorteilhaft.</h1>
          <h3>Das kannst du auch später erledigen.</h3>

          <hr class="green-line" />

          <div v-if="common_infos.big_thumbnail" class="upload-change-wrapper">
            <img
              class="register-avatar register-avatar__big"
              :src="common_infos.big_thumbnail"
              alt=""
            />
            <label class="upload-label" for="upload-photo">Bild ändern</label>
            <input
              class="upload-file-input"
              @change="croppie"
              type="file"
              accept="image/*"
              name="photo"
              id="upload-photo"
            />
          </div>
          <div v-else class="upload-wrapper">
            <label class="upload-label" for="upload-photo">Bild auswählen</label>
            <input
              class="upload-file-input"
              @change="croppie"
              type="file"
              accept="image/*"
              name="photo"
              id="upload-photo"
            />
          </div>

          <br />
          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn color="green white--text" @click="next">Weiter</v-btn>
        </v-stepper-content>

        <v-stepper-content class="content" step="4">
          <h1>Gib hier deine Scoutdaten ein.</h1>

          <hr class="green-line" />

          <label>
            Scoutgebiet
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="$store.state.scoutarea"
            v-model="settings.scoutarea"
            solo
            multiple
          ></v-select>

          <label>
            Scoutbereich
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="$store.state.scout_segment"
            v-model="settings.bundesland"
            solo
            multiple
          ></v-select>

          <div>
            <label>
              Tätig seit
              <span>*</span>
            </label>
            <v-menu
              ref="since_menu"
              v-model="since_menu"
              locale="de"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  color="green"
                  v-model="formatSinceDate"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  solo
                ></v-text-field>
              </template>
              <v-date-picker
                color="green"
                locale="de"
                v-model="settings.working_since"
                type="month"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  min="1900-01-01"
                  :max="new Date().toISOString().substr(0, 10)"
                  color="green white--text"
                  @click="$refs.since_menu.save(settings.working_since)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-menu>
          </div>

          <label>
            Tätig für
            <span>*</span>
          </label>
          <v-text-field
            placeholder="Vereins-, Unternehmens- oder Agenturname "
            color="green"
            v-model="settings.working_for"
            solo
          ></v-text-field>

          <v-btn @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            @click="next"
            :disabled="
              !settings.scoutarea ||
              !settings.bundesland ||
              !settings.working_for ||
              !settings.working_since
            "
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="5">
          <h1>
            Zuletzt brauchen wir noch eine gültige E-Mail-Adresse und ein sicheres
            Passwort.
          </h1>

          <hr class="green-line" />

          <label>E-Mail</label>
          <v-text-field
            :rules="[rules.required]"
            color="green"
            v-model="email"
            solo
          ></v-text-field>

          <label>Passwort</label>
          <v-text-field
            v-model="password"
            :append-icon="showPW ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.min]"
            :type="showPW ? 'text' : 'password'"
            name="input-10-1"
            :loading="loading"
            solo
            color="green"
            hint="min. 8 Zeichen"
            counter
            @click:append="showPW = !showPW"
          ></v-text-field>

          <v-checkbox class="check_nospace" color="green" v-model="checkbox_anb">
            <template v-slot:label>
              <div class="check_label">
                Ich erkläre mich mit den
                <a target="_blank" href="https://www.chance4talents.de/anbs.html"
                  >ANB</a
                >
                der CHANCE4TALENTS GmbH einverstanden.
              </div>
            </template>
          </v-checkbox>

          <v-checkbox
            class="check_nospace"
            color="green"
            v-model="checkbox_datenschutz"
          >
            <template v-slot:label>
              <div class="check_label">
                Ich erkläre mich mit der
                <a target="_blank" href="http://www.chance4talents.de/datenschutz.html"
                  >Datenschutzerklärung</a
                >
                der CHANCE4TALENTS GmbH einverstanden.
              </div>
            </template>
          </v-checkbox>

          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            :loading="loading"
            :disabled="
              password.length < 8 || !email || !checkbox_anb || !checkbox_datenschutz
            "
            @click="registerScout()"
            >Erledigt</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="6">
          <h1 style="color: green; margin: 20px; 0">
            Glückwunsch, deine Registrierung war erfolgreich.
          </h1>
          <h3 style="color: black; margin-bottom: 10px">
            Jetzt fehlt nur noch die offizielle Verifizierung deines Accounts, um den
            begehrten blauen C4T-Ring zu erhalten!
          </h3>
          <h3>
            Geh dazu bitte in dein E-Mail Postfach und bestätige per blauen Button deine
            angegebene E-Mail Adresse.
          </h3>

          <hr class="green-line" />

          <p>
            Hinweis: Solltest du keine E-Mail erhalten haben, dann schau bitte auch in
            deinem SPAM-Ordner nach.
          </p>
          <h3 class="middle_header">
            Vielen Dank für deine Registrierung,<br />dein C4T-Team
          </h3>

          <v-btn color="green white--text" @click="toLogin()">Zum Login</v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <CroppieDialog
      ref="croppieDialog"
      :image="imageSrc"
      :show.sync="showCroppie"
      @upload="cropRegistrationAvatar"
    />
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import firebase from 'firebase';
import { db } from '@/db';
import croppieMixin from '../../mixins/croppie';
import pushMixin from '../../mixins/push-notifications';
import registerMixin from '../../mixins/register';
import CroppieDialog from '../../components/dialogs/CroppieDialog';
import { cloudFunctions } from '../../config';

export default {
  name: 'register-scout',

  data: () => ({
    loading: false,
    sex: ['Männlich', 'Weiblich'],
    menu: false,
    since_menu: false,
    selectedStep: 1,
    email: '',
    name: '',
    showPW: false,
    password: '',
    checkbox_anb: false,
    checkbox_datenschutz: false,
    discount: false,
    common_infos: {
      name: '',
      date: '2018-03-02',
      profile_pic: '',
      history: [],
    },
    search: [
      {
        ageRange: [17, 25],
      },
    ],
    settings: {
      working_for: '',
      userType: 'scout',
      galleryImages: ['', '', '', ''],
      team_country: 'DE',
      player_country: 'Deutschland',
      trainer_country: 'Deutschland',
      newslinks: {
        0: {
          title: '',
          link: '',
        },
        1: {
          title: '',
          link: '',
        },
      },
      videolinks: {
        0: {
          title: '',
          link: '',
        },
        1: {
          title: '',
          link: '',
        },
      },
    },
    rules: {
      required: (value) => !!value || '*Pflichtfeld.',
      min: (v) => v.length >= 8 || '*min. 8 Zeichen',
    },
  }),

  components: {
    CroppieDialog,
  },

  mixins: [croppieMixin, pushMixin, registerMixin],

  beforeMount() {
    this.$gtm.push({
      event: 'registration_start',
      registration_progress: 'start',
      registration_category: 'registerScout',
    });
    if (localStorage.discount) {
      this.discount = true;
    }
  },

  mounted() {
    window.addEventListener('beforeunload', (e) => {
      // Cancel the event
      e.preventDefault();
      // Chrome requires returnValue to be set
      e.returnValue = '';
    });
  },

  computed: {
    formatSinceDate() {
      return this.settings.working_since
        ? moment(this.settings.working_since).format('MM/YYYY')
        : '';
    },
  },

  methods: {
    back() {
      this.selectedStep--;
      this.$gtm.push({
        event: 'registration',
        registration_progress: `step ${this.selectedStep}`,
        registration_category: 'registerScout',
      });
      window.scrollTo(0, 0);
    },

    next() {
      this.selectedStep++;
      this.$gtm.push({
        event: 'registration',
        registration_progress: `step ${this.selectedStep}`,
        registration_category: 'registerScout',
      });
      window.scrollTo(0, 0);
    },

    registerScout() {
      this.loading = true;

      const nationality = this.$store.state.nationalities.find(
        (n) => n.item_text === this.settings.place_of_living,
      );
      const defaultFilterSettings = {
        search_nationality: nationality.id,
      };

      const data = {
        ...this.settings,
        ...this.common_infos,
        ...defaultFilterSettings,
        email: this.email,
        password: this.password,
      };

      if (localStorage.aff) {
        data.affilliateID = localStorage.aff;
      }

      const json = JSON.stringify(data);

      axios({
        method: 'post',
        url: `${cloudFunctions}/createScoutV2`,
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        data: json,
      })
        .then((resp) => {
          this.$store.state.user_uid = resp.data.uid;
          this.loading = false;
        })
        .then(() => {
          this.$gtm.push({
            event: 'registration',
            registration_progress: 'success',
            registration_category: 'registerScout',
          });
          this.selectedStep++;
          window.scrollTo(0, 0);
        })
        .catch((e) => {
          this.loading = false;

          if (
            e.response &&
            e.response.data &&
            e.response.data.error.code === 'auth/invalid-email'
          ) {
            this.$store.commit({
              type: 'openSnackbar',
              text: 'Die Email hat ein falsches Format.',
            });
          } else if (
            e.response &&
            e.response.data &&
            e.response.data.error.code === 'auth/email-already-exists'
          ) {
            this.$store.commit({
              type: 'openSnackbar',
              text: 'Die Email existiert schon.',
            });
          } else {
            this.$store.commit({
              type: 'openSnackbar',
              text: 'Ups. Da ist wohl etwas schief gelaufen',
            });
          }
        });
    },

    login(email, password) {
      this.$store.state.credentials = {
        password,
        email,
      };
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then((userRecord) => {
          const { user } = userRecord;

          const user_id = user.uid;
          this.$store.state.user_id = user_id;
          const userType = user.displayName;
          this.$store.state.userType = userType;
          return { user_id, userType };
        })
        .then((resp) => db.collection(resp.userType).doc(resp.user_id).get())
        .then((snapshot) => {
          const document = snapshot.data();
          this.$store.state.user_data = document;
          return document.userType;
        })
        .then(async (userType) => {
          this.$store.dispatch('bindUserData', {
            userType,
            id: this.$store.state.user_data.id,
          });
          await this.setDefaultMessagingSettings(this.user_data);
        })
        .catch((error) => {
          if (error.code === 'auth/email-already-exists') {
            this.$store.state.snackText = 'Email existiert schon';
            this.$store.state.snackbar = true;
          }
          if (
            error.code === 'auth/wrong-password' ||
            error.code === 'auth/user-not-found'
          ) {
            this.$store.state.snackText = 'Falsche Logindaten';
            this.$store.state.snackbar = true;
          }
          if (error.code === 'auth/invalid-email') {
            this.$store.state.snackText = 'E-Mail hat das falsche Format';
            this.$store.state.snackbar = true;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';
.green-line {
  height: 0;
  border: 0;
  border-bottom: 5px solid $primary-dark;
  border-radius: 4px;
  margin: 40px 20%;
}

.middle_header {
  text-align: center;
  margin-bottom: 4px !important;
  font-weight: 600;
}

.register {
  padding: 0;
  margin: 0;
  text-align: center;
}

.v-btn {
  margin-left: 0;
  border-radius: 15px;
  padding: 15px 30px;

  &.green {
    @include mainLinearGradient;
  }
}

.stepper {
  width: 100%;
  min-height: 100vh;
}

.link-no-team,
a {
  color: #24a23d;
}

label {
  font-weight: bold;
  color: $secondary-dark;
  text-align: center;
  font-size: 1.5rem;

  span:last-of-type {
    color: $secondary-light;
  }
}

.items {
  width: 100%;
  background: rgb(248, 248, 248);
  min-height: 93vh;
}

.datepicker {
  margin-bottom: 20px;
}

.items-1 {
  text-align: center;
}

h1 {
  margin-top: 1rem;
}

h2 {
  color: rgb(34, 34, 34);
  font-weight: 400;
  font-size: 20px;
  font-weight: 500;
}

h3 {
  color: $secondary-light;
}

.small-icon {
  align-self: center;
  height: 33px;
}

.icon-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
